import { ComponentsOverrides } from "@mui/material";

const styleOverrides: ComponentsOverrides["MuiRadio"] = {
  root: {
    color: "#6d9c15 !important",
  },
};

const StyledRadio = {
  styleOverrides,
};

export default StyledRadio;
